import React, { useState, useEffect } from "react";
import axios from "axios";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import "../styles/components/popularMovies.scss";
import { Audio } from "react-loading-icons";
import { useHistory, Link } from "react-router-dom";

const API_KEY = process.env.REACT_APP_TMDB_API_KEY;

const PopularMovies = () => {
	const [popular, setPopular] = useState([]);
	const [tendances, setTendances] = useState([]);
	const [mystère, setMystère] = useState([]);
	const [romance, setRomance] = useState([]);
	const [telefilm, setTelefilm] = useState([]);
	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const history = useHistory();

	useEffect(() => {
		const sections = [
			{
				setter: setPopular,
				url: `https://api.themoviedb.org/3/movie/popular?api_key=${API_KEY}&language=fr-FR&page=${page}`,
			},
			{
				setter: setTendances,
				url: `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&language=fr-FR&with_genres=10402&page=${page}`,
			},
			{
				setter: setMystère,
				url: `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&language=fr-FR&with_genres=9648&page=${page}`,
			},
			{
				setter: setRomance,
				url: `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&language=fr-FR&with_genres=10749&page=${page}`,
			},
			{
				setter: setTelefilm,
				url: `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&language=fr-FR&with_genres=10770&page=${page}`,
			},
		];

		setLoading(true);
		Promise.all(
			sections.map(({ setter, url }) =>
				axios.get(url).then((res) => setter(res.data.results))
			)
		).finally(() => setLoading(false));
	}, [page]);

	return (
		<div className="popularMovies">
			{loading ? (
				<div className="audio">
					<Audio stroke="#98ff98" strokeOpacity={0.125} speed={0.75} />
				</div>
			) : (
				<div>
					<header className="header-accueil">
						<div className="row">
							<div className="col-fluid col-lg col-md col-sd">
								<Splide
									options={{
										autoplay: true,
										type: "loop",
										drag: false,
										perPage: 1,
										interval: 5000,
										pauseOnHover: false,
										rewind: true,
										speed: 3000,
										pagination: false,
										arrows: false,
										updateOnMove: true,
									}} 
									>
									{popular.map((p) => (
										<SplideSlide key={p.id}>
											<div
												className="splide__img"
												onClick={() =>
													history.push(`/movieDetails/${p.id}`)
												}>
												
													<img
														src={`https://image.tmdb.org/t/p/w1280/${p.backdrop_path}`}
														className="img-fluid"
														alt={p.title}
													/>
												
											</div>
										</SplideSlide>
									))}
								</Splide>
							</div>
						</div>
					</header>

					<div className="accueil-body">
						<div className="accueil-container">
							<div className="section-tendances-accueil">
								<div className="d-flex">
									<h2>Tendances</h2>
									<div className="btn-tendances">
										<Link to="/categories">Catégories</Link>
									</div>
								</div>
							</div>
						</div>
						<div className="tendances-carrousel">
							<Splide
								options={{
									type: "slide",
									perPage: 3,
									perMove: 1,
									gap: "15px",
									width: "min(1200px, 100% - 1150px)",
									type: "loop",
									breakpoints: {
										992: { perPage: 2 },
										480: { perPage: 1, rewind: true },
									},
								}}>
								{tendances.map((p) => (
									<SplideSlide key={p.id}>
										<div className="card">
											<a
												onClick={() =>
													history.push(`/movieDetails/${p.id}`)
												}>
												<img
													className="card__image"
													src={`https://image.tmdb.org/t/p/original/${p.poster_path}`}
													alt={`photo-film-${p.title}`}
												/>
												<div className="card__content">
													<h3 className="card__title">{p.title}</h3>
												</div>
											</a>
										</div>
									</SplideSlide>
								))}
							</Splide>
						</div>

						<div className="accueil-container">
							<div className="tendances-carrousel">
								<h2>Mystère</h2>
								<Splide
									options={{
										type: "slide",
										perPage: 3,
										perMove: 1,
										gap: "15px",
										width: "min(1200px, 100% - 1150px)",
										type: "loop",
										breakpoints: {
											992: { perPage: 2 },
											480: { perPage: 1, rewind: true },
										},
									}}>
									{mystère.map((p) => (
										<SplideSlide key={p.id}>
											<div className="card">
												<a
													onClick={() =>
														history.push(`/movieDetails/${p.id}`)
													}>
													<img
														className="card__image"
														src={`https://image.tmdb.org/t/p/original/${p.poster_path}`}
														alt={`photo-film-${p.title}`}
													/>
													<div className="card__content">
														<h3 className="card__title">{p.title}</h3>
													</div>
												</a>
											</div>
										</SplideSlide>
									))}
								</Splide>
							</div>
						</div>

						<div className="accueil-container">
							<div className="tendances-carrousel">
								<h2>Romance</h2>
								<Splide
									options={{
										type: "slide",
										perPage: 3,
										perMove: 1,
										gap: "15px",
										width: "min(1200px, 100% - 1150px)",
										type: "loop",
										breakpoints: {
											992: { perPage: 2 },
											480: { perPage: 1, rewind: true },
										},
									}}>
									{romance.map((p) => (
										<SplideSlide key={p.id}>
											<div className="card">
												<a
													onClick={() =>
														history.push(`/movieDetails/${p.id}`)
													}>
													<img
														className="card__image"
														src={`https://image.tmdb.org/t/p/original/${p.poster_path}`}
														alt={`photo-film-${p.title}`}
													/>
													<div className="card__content">
														<h3 className="card__title">{p.title}</h3>
													</div>
												</a>
											</div>
										</SplideSlide>
									))}
								</Splide>
							</div>
						</div>

						<div className="accueil-container">
							<div className="tendances-carrousel">
								<h2>Téléfilm</h2>
								<Splide
									options={{
										type: "slide",
										perPage: 3,
										perMove: 1,
										gap: "15px",
										width: "min(1200px, 100% - 1150px)",
										type: "loop",
										breakpoints: {
											992: { perPage: 2 },
											480: { perPage: 1, rewind: true },
										},
									}}>
									{telefilm.map((p) => (
										<SplideSlide key={p.id}>
											<div className="card">
												<a
													onClick={() =>
														history.push(`/movieDetails/${p.id}`)
													}>
													<img
														className="card__image"
														src={`https://image.tmdb.org/t/p/original/${p.poster_path}`}
														alt={`photo-film-${p.title}`}
													/>
													<div className="card__content">
														<h3 className="card__title">{p.title}</h3>
													</div>
												</a>
											</div>
										</SplideSlide>
									))}
								</Splide>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default PopularMovies;
